import styled, { WithTheme } from '@emotion/styled';
import { typography, color } from 'styled-system';
import { css } from '@emotion/core';
import { Theme, StyledProps } from './Text.types';
import { StyledProps as Props } from './Text.types';

export const Text = styled.p<StyledProps, Theme>`
  color: 'var(--color-smoke)';

  ${color}
  ${typography}
  ${(p: WithTheme<Props, Theme>) =>
    css({
      fontSize: p.theme?.sizes?.font?.base,
      lineHeight: p.theme?.lineHeight?.base,
    })}
`;

export default Text;
